const initialState = { 
  loading: false,
  payload: [],
  page: 1,
  pages: 1,
  error: null
}

function listCategoryReducer(state = initialState, action) {
  switch (action.type) {
    case 'LIST_CATEGORY_BEGIN':
      return {
        ...state,
        loading: true,
        error: null
      }

    case 'LIST_CATEGORY_SUCCESS':
      return {
        ...state,
        loading: false,
        page: action.page,
        pages: action.pages,
        payload: action.payload
      }

    case 'LIST_CATEGORY_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default listCategoryReducer